export default {
    // charger
    CUSTOM_UI: 'customUI',
    BRIGHTNESS: 'brightness',
    // holder
    PAUSE_MODE: 'pauseMode',
    FLEX_PUFF: 'flexPuff',
    FLEX_BATTERY: 'flexBattery',
    DEVICE_LOCK: 'parentProtection',
    AUTO_START: 'autoStartHeating',
    HEATING_VIBRATION: 'heatingVibration',
    BATTERY_CHARGED: 'uiBatteryChargedVibration',
    DOUBLE_TAP_GESTURE: 'doubleTapGesture',
    LIFT_UP_GESTURE: 'liftUpGesture',
    LED_INTENSITY: 'ledIntensity',
    VIBRATION_INTENSITY: 'vibrationIntensity',
    TUNABILITY: 'tunability',
    REMEMBER_HEATING_PROFILE: 'rememberHeatingProfile',
    RANGE_MODE: 'rangeMode',
};
